import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import LearnerPortfolioFeed from "LearnerPortfolioFeed";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: ":learnerPortfolioGroupId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import("./components"),
          import("LearnerPortfolio/modules/LearnerPortfolioModule"),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1;
          injectReducer(store, {
            key: reducer.NAME,
            reducer: reducer.default,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [LearnerPortfolioFeed(store)],
  };
};
